import { type RPPDomain } from 'utils/core/RPPCore.types'
import { NavItem } from 'legacy/components/Nav/nav.types'
import { retailerCollectionsRouter } from 'domains/retailer-collections/routing/retailerCollectionsRouter'
import { retailerCollectionsV2Router } from 'domains/retailer-collections/routing/retailerCollectionsV2Router'
import { type DomainMessages } from 'domains/retailer-collections/utils/domain/intl'
import { routes } from 'domains/retailer-collections/routing/routes'
import EN_US from 'domains/retailer-collections/translations/en-US'
import { type DomainAccessControlConfig } from 'domains/retailer-collections/utils/domain/accessControl'
import { retailerCollectionsV1NavigationItem } from 'domains/retailer-collections/access-control/retailerCollectionsAccess.configuration'
import { retailerCollectionsV2AccessControl } from 'domains/retailer-collections/access-control/retailerCollectionsV2Access.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'retailer-collections',
  routes,
  translations: { EN_US },
  routers: {
    scoped: [retailerCollectionsV2Router, retailerCollectionsRouter],
  },
  navigationEntries: [
    {
      attachTo: NavItem.Merchandising,
      subNavItems: [
        {
          type: 'item',
          labelId: 'retailerCollectionsDomain.title',
          route: 'retailer-collections-browse',
          accessControl: retailerCollectionsV1NavigationItem,
        },
      ],
    },
    {
      attachTo: NavItem.Catalog,
      subNavItems: [
        {
          type: 'item',
          labelId: 'retailerCollectionsDomain.v2.list.title',
          route: 'retailer-collections-v2-list',
          accessControl: retailerCollectionsV2AccessControl,
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
